export default "__VITE_ASSET__BzxeQgOv__ 55w, __VITE_ASSET__BDpU4_rH__ 110w, __VITE_ASSET__CubHlxdp__ 165w";